import {
  ArrayMinSize,
  IsArray,
  IsBoolean,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  ValidateNested,
} from 'class-validator';

export class LineItemConfigurationTaxCodeDto {
  @IsNotEmpty()
  @IsUUID(4)
  id!: string;
  @IsNotEmpty()
  @IsUUID(4)
  countryId!: string;
  @IsNotEmpty()
  @IsString()
  taxName!: string;
  @IsOptional()
  @IsString()
  taxAbbreviation?: string;
  @IsNotEmpty()
  @IsNumber()
  taxAmount!: number;
  @IsOptional()
  @IsString()
  explanationShort?: string;
  @IsOptional()
  @IsString()
  explanationLong?: string;
  @IsNotEmpty()
  @IsBoolean()
  displayExplanation!: boolean;
}

export class LineItemConfigurationResultDto {
  @IsNotEmpty()
  @IsUUID(4)
  id!: string;
  @IsNotEmpty()
  @IsUUID(4)
  globalServiceProviderId!: string;
  @IsNotEmpty()
  @IsString()
  name!: string;
  @IsNotEmpty()
  @IsNumber()
  amount!: number;
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  taxCodes!: LineItemConfigurationTaxCodeDto[] | undefined;
}

export class CreateLineItemConfigurationDto {
  @IsNotEmpty()
  @IsString()
  name!: string;
  @IsNotEmpty()
  @IsNumber()
  amount!: number;
  @IsOptional()
  @IsArray()
  @IsUUID(4, { each: true })
  @ArrayMinSize(1)
  taxCodes: string[] | undefined;
}

export const LineItemConfigurationControllerDefinition = {
  controller: ':globalServiceProviderId/line-item-configuration',
  endpoints: {
    getLineItemConfigurations: {
      method: 'GET',
      url: '',
      response: undefined as unknown as LineItemConfigurationResultDto[],
      body: undefined,
      query: undefined,
    },
    postLineItemConfiguration: {
      method: 'POST',
      url: '',
      response: undefined as unknown as LineItemConfigurationResultDto,
      body: undefined as unknown as CreateLineItemConfigurationDto,
      query: undefined,
    },
    deleteLineItemConfiguration: {
      method: 'DELETE',
      url: ':id',
      response: undefined as unknown as { success: boolean },
      body: undefined,
      query: undefined,
    },
  },
} as const;

export type LineItemConfigurationControllerResultTypes = {
  [key in keyof (typeof LineItemConfigurationControllerDefinition)['endpoints']]: (typeof LineItemConfigurationControllerDefinition)['endpoints'][key]['response'];
};
export type LineItemConfigurationControllerQueryTypes = {
  [key in keyof (typeof LineItemConfigurationControllerDefinition)['endpoints']]: (typeof LineItemConfigurationControllerDefinition)['endpoints'][key]['query'];
};
export type LineItemConfigurationControllerBodyTypes = {
  [key in keyof (typeof LineItemConfigurationControllerDefinition)['endpoints']]: (typeof LineItemConfigurationControllerDefinition)['endpoints'][key]['body'];
};
